/**
 * WordPress dependencies
 */
import { createSlotFill } from '@wordpress/components';

var _createSlotFill = createSlotFill('__experimentalBlockSettingsMenuFirstItem'),
    __experimentalBlockSettingsMenuFirstItem = _createSlotFill.Fill,
    Slot = _createSlotFill.Slot;

__experimentalBlockSettingsMenuFirstItem.Slot = Slot;
export default __experimentalBlockSettingsMenuFirstItem;
//# sourceMappingURL=block-settings-menu-first-item.js.map